import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from './../../services/authentication/authentication.service';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ConfirmedValidator } from './confirmed.validator';
import { TranslateService } from '../../services/translate/translate.service';
import { FieldsProfileI } from '../../interfaces/user.interface';
import { SafeResourceUrl } from '@angular/platform-browser';
import { MatMenuTrigger } from '@angular/material/menu';
import { AddressModalComponent } from '../address-modal/address-modal.component';
import { Address } from '../../interfaces/address.interface';
import { IUser } from '../../interfaces/toolbar/toolbar.interface';

interface translateModalUser {
  nameUpdate: string;
  fullName: string;
  placeholderFullName: string;
  fullnameRequired: string;
  username: string;
  placeholderUsername: string;
  usernameRequired: string;
  email: string;
  placeholderEmail: string;
  emailRequired: string;
  phone: string;
  placeholderPhone: string;
  phoneRequired: string;
  phoneValid: string;
  password: string;
  placeholderPassword: string;
  passwordRequired: string;
  confirmPassword: string;
  placeholderConfirmPassword: string;
  confirmPasswordRequired: string;
  confirmPasswordNotMatch: string;
  buttonSave: string;
  toastUpdateTitle: string;
  toastUpdateDescription: string;
  buttonCancel: string;
  errorLoadImage: string;
  addPhoto: string;
  editPhoto: string;
  loadPhoto: string;
  deletePhoto: string;
  avatar: string;
  placeholderKey: string;
  placeholderValue: string;
}

declare var google: any;

@Component({
  selector: 'mg-modal-users',
  templateUrl: './modal-users.component.html',
  styleUrls: ['./modal-users.component.scss'],
})
export class ModalUsersComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @Input() viewTitle!: boolean;
  @Input() dataUser!: { pk: string; sk: string };
  @Input() urlAccess: string = '';
  @Input() viewProfile!: boolean;
  @Input() urlTranslate: string =
    'https://cdn.mango-soft.com/webcomponents/bein/assets/en.json';

  @Input() optionsFieldsProfile: FieldsProfileI[] = [];
  @Output() changeUser: EventEmitter<IUser> = new EventEmitter<IUser>();

  type = 'password';
  type2 = 'password';
  separateDialCode = false;
  formUser!: FormGroup;
  formProfile!: FormGroup;
  accepts = ['png', 'jpg', 'svg', 'jpeg', 'webp'];
  translateModal: translateModalUser = {} as translateModalUser;
  subscriptionTranslate!: Subscription;
  srcData!: SafeResourceUrl;
  tokenId: number = 0;
  isMenuOpen: boolean = false;
  user!: IUser;
  address!: Address;

  rootViewTitle: boolean = true;
  rootDataUser!: { pk: string; sk: string };
  rootUrlAccess: string = '';
  rootViewProfile: boolean = false;
  rootOptionsFieldsProfile: FieldsProfileI[] = [];
  loading: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    @Optional() public dialogRef: MatDialogRef<ModalUsersComponent>,
    private translate: TranslateService,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: {
      data: IUser;
      url: string;
      viewTitle: boolean;
      viewProfile: boolean;
      optionsFieldsProfile: FieldsProfileI[];
    },
    private authService: AuthenticationService,
    private dialog: MatDialog,
    private toast: ToastrService // private toast: NotificationsService
  ) {
    this.dataTranslate();
  }

  async ngOnInit() {
    this.updateVariables();
    await this.getDataUser();
    this.initModalUsers();
    this.loading = false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.updateVariables();
  }

  updateVariables() {
    this.rootViewTitle =
      this.viewTitle === true || this.viewTitle === false
        ? this.viewTitle
        : this.data?.viewTitle || true;
    this.rootDataUser = this.dataUser || this.data.data;
    this.rootOptionsFieldsProfile =
      this.optionsFieldsProfile || this.data.data || [];
    this.rootViewProfile = this.viewProfile || this.data.viewProfile || false;
    this.rootUrlAccess = this.urlAccess || this.data.url;
  }

  async getDataUser() {
    this.user = (
      await firstValueFrom(
        this.authService.getUser(
          this.rootUrlAccess,
          this.rootDataUser.pk,
          this.rootDataUser.sk
        )
      )
    ).data;
  }

  ngAfterViewInit() {
    this.menuTrigger?.menuOpened.subscribe(() => {
      this.isMenuOpen = true;
    });

    this.menuTrigger?.menuClosed.subscribe(() => {
      this.isMenuOpen = false;
    });
  }
  initModalUsers() {
    this.srcData =
      this.user?.picture ||
      'https://s3.amazonaws.com/cdn.mango-soft.com/access-control/person-placeholder.png';
    this.formUser = this.formBuilder.group(
      {
        fullName: [this.user?.fullName, [Validators.required]],
        username: [this.user?.username, [Validators.required]],
        email: [this.user?.email, [Validators.required, Validators.email]],
        password: ['', [Validators.minLength(4)]],
        confirmPassword: ['', [Validators.minLength(4)]],
      },
      {
        validator: ConfirmedValidator('password', 'confirmPassword'),
      }
    );
    this.initFormProfile();
    this.formUser.controls['email'].disable({ onlySelf: true });
    this.formUser.controls['username'].disable({ onlySelf: true });
  }

  get f() {
    return this.formUser?.controls;
  }

  urlUploadedHandle(file: any) {
    this.srcData = file.url;
  }

  save() {
    if (!this.formUser.invalid) {
      const { confirmPassword, password, phone, fullName } =
        this.formUser.value;
      let user: IUser = {
        ...this.user,
        fullName,
        phone: this.user.phone,
        picture: this.srcData,
        email: this.user.email,
        username: this.user.username,
        modifyGroups: true,
        modifyStatus: false,
        groups: this.user.groups || [],
      } as IUser;
      if (this.rootViewProfile) {
        let profile = {
          ...this.user.profile,
        };
        this.fields.controls.forEach((item) => {
          const value = item.value;
          if (value.key === 'address') {
            profile[value.key] = this.address;
          } else if (value.key === 'terms' || value.key === 'policy') {
            profile[value.key] = value.value === 'true' || value.value === true;
          } else {
            profile[value.key] = value.value;
          }
        });
        user = {
          ...user,
          profile,
        };
      }
      if (password.length > 0 && password === confirmPassword) {
        user.password = password;
      }
      this.authService
        .updatetUser(
          this.rootUrlAccess,
          this.rootDataUser.pk,
          this.rootDataUser.sk,
          user
        )
        .subscribe(
          (resp) => {
            this.changeUser.emit(resp);
            this.toast.success(
              this.translateModal.toastUpdateTitle,
              this.translateModal.toastUpdateDescription
            );
            user.picture = this.srcData as string;
            if (this.data?.data) {
              this.dialogRef.close(user);
            }
          },

          (error) => {
            this.changeUser.emit(error);
            this.toast.success(
              'Error',
              error.error.errorMessage || 'Internal Error'
            );
            this.dialogRef.close();
          }
        );
      if (this.data?.data) {
        this.dialogRef.close(user);
      }
    }
  }

  get form(): {
    [key: string]: AbstractControl;
  } {
    return this.formProfile?.controls;
  }

  get fields() {
    return this.formProfile?.get('profile') as FormArray;
  }

  removeField(index: number) {
    this.fields.removeAt(index);
  }

  initFormProfile() {
    this.formProfile = this.formBuilder.group({
      profile: this.formBuilder.array([]),
    });
    const dataProfile = this.user?.profile || {};
    if (dataProfile) {
      Object.keys(dataProfile).forEach((key) => {
        const itemView = this.rootOptionsFieldsProfile.findIndex(
          (item) => item.key === key
        );
        if (itemView !== -1 && this.rootOptionsFieldsProfile[itemView].view) {
          if (key === 'address') {
            this.address = dataProfile[key];
            if (!dataProfile[key]?.address) {
              const latLng = {
                lat: parseInt(dataProfile[key].lat),
                lng: parseInt(dataProfile[key].lng),
              };
              const geocoder = new google.maps.Geocoder();

              geocoder.geocode(
                { location: latLng },
                (results: any, status: any) => {
                  if (status === google.maps.GeocoderStatus.OK) {
                    if (results[0]) {
                      let address = results[0].formatted_address;
                      this.address.address = address;
                      const group = this.formBuilder.group({
                        key: [key, Validators.required],
                        value: [
                          this.generateAddress(this.address),
                          Validators.required,
                        ],
                      });
                      group.controls['value'].disable({ onlySelf: true });
                      this.fields.push(group);
                    } else {
                      console.log(
                        'No se encontró ninguna dirección para las coordenadas proporcionadas.'
                      );
                    }
                  } else {
                    console.log('Geocoding falló debido a:', status);
                  }
                }
              );
            } else {
              const group = this.formBuilder.group({
                key: [key, Validators.required],
                value: [
                  this.generateAddress(dataProfile[key]),
                  Validators.required,
                ],
              });
              group.controls['value'].disable({ onlySelf: true });
              this.fields.push(group);
            }
          } else {
            const group = this.formBuilder.group({
              key: [key, Validators.required],
              value: [dataProfile[key], Validators.required],
            });
            if (this.optionsFieldsProfile[itemView].disabled) {
              group.controls['value'].disable({ onlySelf: true });
            }
            this.fields.push(group);
          }
        }
      });
    }
  }
  generateAddress = (address: Address) => {
    if (!address || !address.address) {
      return ''; // Si el objeto o la dirección no son válidos, devolver cadena vacía
    }
    const { address: fullAddress, state, city, country } = address;

    const mainAddress = fullAddress.split(',')[0].trim();
    const addressParts = [mainAddress, state, city, country].filter(
      (part) => part && part.trim()
    ); // Filtrar valores nulos o vacíos
    return addressParts.join(', '); // Unir las partes con coma
  };

  openAddressModal() {
    const dialogRef = this.dialog.open(AddressModalComponent, {
      height: '666px',
      width: '500px',
      data: this.address,
    });

    dialogRef.afterClosed().subscribe((address: Address) => {
      if (address) {
        this.address = address;
        const indexGroup = this.fields.controls.findIndex(
          (item) => item.value.key === 'address'
        );
        const group = this.fields.controls[indexGroup];
        group.patchValue({ value: this.generateAddress(this.address) });
        this.fields.controls.splice(indexGroup, 1, group);
      }
    });
  }

  openLoadImage() {
    const item = document.getElementById(`file-upload-${this.tokenId}`);
    item?.click();
  }
  dataTranslate() {
    this.subscriptionTranslate = this.translate.init('core').subscribe(
      (data) => {
        this.translateModal = data.toolbar.modalUsers;
      },
      async (error) => {
        const getData = await fetch(this.urlTranslate);
        const data = await getData.json();
        this.translateModal = data;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
